import { DateTime } from 'luxon'
import { z } from 'zod'

export interface RegisterFormData {
  born_date: string | null
  confirm_password: string
  documentNumber: string
  documentType: number
  email: string
  lastname1: string
  lastname2: string
  name: string
  password: string
  phone_number: string
  term_conditions: boolean
  sex: number
}

export interface SuccessInputs {
  password: boolean
  confirm_password: boolean
  phone_number: boolean
  email: boolean
}

export const initialForm: RegisterFormData = {
  born_date: null,
  confirm_password: '',
  documentNumber: '',
  documentType: 1,
  email: '',
  lastname1: '',
  lastname2: '',
  name: '',
  password: '',
  phone_number: '',
  term_conditions: false,
  sex: 2
}

const ERRORS = {
  born_date: {
    required_error: 'Este campo es requerido',
    invalid_type_error: 'Ingresa una fecha válida'
  },
  documentNumber: {
    required_error: 'Este campo es requerido',
    invalid_type_error: 'Ingresa un DNI válido'
  },
  documentType: {
    required_error: 'Este campo es requerido',
    invalid_type_error: 'Ingresa una opción válida'
  },
  email: {
    required_error: 'Este campo es requerido',
    invalid_type_error: 'Ingresa un correo electrónico válido'
  },
  lastname1: {
    required_error: 'Este campo es requerido',
    invalid_type_error: 'Ingresa un apellido válido'
  },
  lastname2: {
    required_error: 'Este campo es requerido',
    invalid_type_error: 'Ingresa un apellido válido'
  },
  name: {
    required_error: 'Este campo es requerido',
    invalid_type_error: 'Ingresa un nombre válido'
  },
  phone_number: {
    required_error: 'Este campo es requerido',
    invalid_type_error: 'Ingresa un número de teléfono válido',
    length_error: 'El celular debe contener 9 dígitos'
  },
  term_conditions: {
    required_error: 'Debes aceptar los términos y condiciones',
    invalid_type_error: 'Ingresa una opción válida'
  },
  sex: {
    required_error: 'Este campo es requerido',
    invalid_type_error: 'Ingresa una opción válida'
  },
  password: {
    required_error: 'Este campo es requerido',
    invalid_type_error: 'Ingresa una contraseña válida',
    min_length_error: 'Mínimo 8 caracteres'
    // max_length_error: 'Máximo 12 caracteres',
    // lowercase_error: 'Debe incluir una letra minúscula',
    // uppercase_error: 'Debe incluir una letra mayúscula',
    // number_error: 'Debe incluir un número',
    // special_characters_error: 'Debe incluir un caracter especial (!, @, #, $)'
  },
  confirm_password: {
    required_error: 'Este campo es requerido',
    mismatch_error: 'Las contraseñas no coinciden'
  }
} as const

export const registerSchema = z
  .object({
    born_date: z
      .string()
      .nullable()
      .refine(value => value !== null, { message: ERRORS.born_date.required_error })
      .refine(value => value && DateTime.fromISO(value).isValid, {
        message: ERRORS.born_date.invalid_type_error
      }),
    confirm_password: z.string().nonempty(ERRORS.confirm_password.required_error),
    password: z
      .string()
      .nonempty(ERRORS.password.required_error)
      .min(8, ERRORS.password.min_length_error),
    documentNumber: z.string().nonempty(ERRORS.documentType.required_error),
    documentType: z.number().refine(value => Boolean(value), ERRORS.documentType.required_error),
    email: z.string().email(ERRORS.email.invalid_type_error),
    lastname1: z.string().nonempty(ERRORS.lastname1.required_error),
    lastname2: z.string().nonempty(ERRORS.lastname2.required_error),
    name: z.string().nonempty(ERRORS.name.required_error),
    phone_number: z
      .string()
      .nonempty(ERRORS.phone_number.required_error)
      .max(9, ERRORS.phone_number.length_error)
      .min(9, ERRORS.phone_number.length_error),
    term_conditions: z
      .boolean()
      .refine(value => value, { message: ERRORS.term_conditions.required_error }),
    sex: z.number().refine(value => Boolean(value), ERRORS.sex.required_error)
  })
  .superRefine(({ password, confirm_password: confirmPassword }, ctx) => {
    if (password !== confirmPassword) {
      ctx.addIssue({
        message: 'Las contraseñas no coinciden',
        path: ['confirm_password'],
        code: z.ZodIssueCode.custom
      })

      return z.NEVER
    }
  })
